import {
  useDeleteTherapist,
  useGetAllActiveTherapist,
  useGetAllAdminAndTherapist,
} from '_api';
import { ACCOUNT_TYPE } from '_constants';
import { useMemo } from 'react';

const useTherapists = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { mutateAsync: deleteTherapist } = useDeleteTherapist();
  const { data: allTherapist, isFetching: isLoading } = useGetAllAdminAndTherapist({
    page,
    size,
  });
  const { data: activeTherapist } = useGetAllActiveTherapist({
    page,
    size,
  });

  const allActiveTherapistAndAdmin = useMemo(
    () =>
      allTherapist && !isLoading
        ? allTherapist.filter(
            (therapistOrAdmin) =>
              therapistOrAdmin.status === 'ACTIVE' ||
              therapistOrAdmin.status === 'AWAITING_ACTIVATION',
          )
        : [],
    [allTherapist, isLoading],
  );

  const therapistOptions = useMemo(
    () =>
      allTherapist
        ? allTherapist.flatMap((therapist) =>
            therapist.accountType === ACCOUNT_TYPE.THERAPIST
              ? {
                  description: therapist.firstName + ' ' + therapist.lastName,
                  name: therapist.id.toString(),
                }
              : [],
          )
        : [],
    [allTherapist],
  );

  return {
    allActiveTherapistAndAdmin,
    allTherapist,
    activeTherapist,
    deleteTherapist,
    therapistOptions,
    isLoading,
  };
};

export default useTherapists;
